// import React, { useEffect, useMemo } from "react";
// import { useNavigate, Outlet, useLocation } from "react-router-dom";
// import "../Auth/styles.css"; // contains .auth-section & .form-box

// function useAuthBgFromQuery() {
//   const { search } = useLocation();

//   return useMemo(() => {
//     const p = new URLSearchParams(search);

//     const normalizeHex = (v) => {
//       if (!v) return "";
//       const cleaned = v.startsWith("#") ? v.slice(1) : v;
//       if (
//         /^[0-9a-fA-F]{6}$/.test(cleaned) ||
//         /^[0-9a-fA-F]{3}$/.test(cleaned)
//       ) {
//         return `#${cleaned}`;
//       }
//       return "";
//     };

//     const isHttpUrl = (s) => {
//       if (!s) return false;
//       try {
//         const u = new URL(s);
//         return u.protocol === "http:" || u.protocol === "https:";
//       } catch {
//         return false;
//       }
//     };

//     const hexToRgb = (hex) => {
//       if (!hex) return null;
//       const h = hex.replace("#", "");
//       const full =
//         h.length === 3
//           ? h
//               .split("")
//               .map((c) => c + c)
//               .join("")
//           : h;
//       const n = parseInt(full, 16);
//       return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
//     };

//     const darken = (hex, pct = 0.2) => {
//       const rgb = hexToRgb(hex);
//       if (!rgb) return hex;
//       const k = 1 - pct;
//       const r = Math.max(0, Math.min(255, Math.round(rgb.r * k)));
//       const g = Math.max(0, Math.min(255, Math.round(rgb.g * k)));
//       const b = Math.max(0, Math.min(255, Math.round(rgb.b * k)));
//       return `#${[r, g, b]
//         .map((x) => x.toString(16).padStart(2, "0"))
//         .join("")}`;
//     };

//     const rgba = (hex, a = 0.6) => {
//       const rgb = hexToRgb(hex);
//       if (!rgb) return "";
//       return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`;
//     };

//     const primary = normalizeHex(p.get("primary"));
//     const secondary = normalizeHex(p.get("secondary"));
//     const bgHex = normalizeHex(p.get("bg"));

//     const bgImageRaw = p.get("bg_image");
//     const hasImage = isHttpUrl(bgImageRaw);
//     const bgImageUrl = hasImage ? `url("${bgImageRaw}")` : "";
    
//     // `url("https://images.pexels.com/photos/301664/pexels-photo-301664.jpeg")`;

//     // Decide gradient:
//     // 1) If primary/secondary given → use them.
//     // 2) Else if only bg given → darken(bg) -> bg.
//     // 3) Else → no gradient (lets default image show).
//     let gradient = "";
//     if (primary && secondary) {
//       gradient = hasImage
//         ? `linear-gradient(135deg, ${rgba(primary, 0.65)}, ${rgba(
//             secondary,
//             0.65
//           )})`
//         : `linear-gradient(135deg, ${primary}, ${secondary})`;
//     } else if (bgHex) {
//       const d = darken(bgHex, 0.25);
//       gradient = hasImage
//         ? `linear-gradient(135deg, ${rgba(d, 0.6)}, ${rgba(bgHex, 0.6)})`
//         : `linear-gradient(135deg, ${d}, ${bgHex})`;
//     }

//     // If color/gradient but NO image, suppress default image by setting 'none'
//     const bgImageVar = hasImage ? bgImageUrl : gradient ? "none" : undefined;

//     return { gradient, bgImageVar };
//   }, [search]);
// }

// function useHeadFromQuery() {
//   const { search } = useLocation();

//   console.log("useHeadFromQuery - search:", search);

//   useEffect(() => {
//     const p = new URLSearchParams(search);
//     const incomingTitle = p.get("title");      // e.g. ?title=Kodefast%20Signin
//     const faviconParam = p.get("favicon");     // e.g. ?favicon=https%3A%2F%2F.../logo.png (or data:image/png;base64,...)
//     const primary = p.get("primary");          // optional: for theme-color

//     console.log("useHeadFromQuery:", { incomingTitle, faviconParam, primary });
//     // Store previous to restore on unmount
//     const prevTitle = document.title;

//     // Find or create <link rel="icon" id="auth-dynamic-favicon">
//     const ensureIcon = () => {
//       let link = document.querySelector('link[rel="icon"]#auth-dynamic-favicon');
//       if (!link) {
//         link = document.createElement("link");
//         link.rel = "icon";
//         link.id = "auth-dynamic-favicon";
//         document.head.appendChild(link);
//       }
//       return link;
//     };

//     // Find or create <meta name="theme-color" id="auth-dynamic-theme-color">
//     const ensureThemeMeta = () => {
//       let meta = document.querySelector('meta[name="theme-color"]#auth-dynamic-theme-color');
//       if (!meta) {
//         meta = document.createElement("meta");
//         meta.setAttribute("name", "theme-color");
//         meta.id = "auth-dynamic-theme-color";
//         document.head.appendChild(meta);
//       }
//       return meta;
//     };

//     // Basic URL/data check for favicon
//     const isValidFavicon = (s) => {
//       if (!s) return false;
//       if (s.startsWith("data:image/")) return true;
//       try {
//         const u = new URL(s);
//         return u.protocol === "http:" || u.protocol === "https:";
//       } catch {
//         return false;
//       }
//     };

//     // Apply title
//     if (incomingTitle && incomingTitle.trim()) {
//       document.title = incomingTitle.trim();
//     }

//     // Apply favicon
//     let prevHref;
//     if (isValidFavicon(faviconParam)) {
//       const link = ensureIcon();
//       prevHref = link.getAttribute("href");
//       link.setAttribute("href", faviconParam);
//       // Optional: best compatibility with multiple sizes/types could add rel="icon shortcut icon"
//     }

//     // Apply theme-color if primary provided
//     let prevThemeContent;
//     if (primary && /^#?[0-9a-fA-F]{3,6}$/.test(primary)) {
//       const normalized = primary.startsWith("#") ? primary : `#${primary}`;
//       const meta = ensureThemeMeta();
//       prevThemeContent = meta.getAttribute("content");
//       meta.setAttribute("content", normalized);
//     }

//     // Cleanup: restore previous head state on unmount
//     return () => {
//       document.title = prevTitle;
//       const link = document.querySelector('link[rel="icon"]#auth-dynamic-favicon');
//       if (link && prevHref != null) {
//         link.setAttribute("href", prevHref);
//       }
//       const meta = document.querySelector('meta[name="theme-color"]#auth-dynamic-theme-color');
//       if (meta && prevThemeContent != null) {
//         meta.setAttribute("content", prevThemeContent);
//       }
//     };
//   }, [search]);
// }

// function PublicClientLayout({ children }) {
//   const navigate = useNavigate();
//     useHeadFromQuery();
//   const { gradient, bgImageVar } = useAuthBgFromQuery();

//   const styleVars = {
//     "--auth-gradient": gradient || "none",
//     "--auth-bg-image": bgImageVar, // 'url(...)' | 'none' | undefined (fallback to default)
//   };
//   useEffect(() => {
//     const token = localStorage.getItem("access_token");
//     if (token) navigate("/clients");
//   }, [navigate]);

//   return (
//     <section style={styleVars}>
//       <div className="form-box">
//         {children}
//         <Outlet />
//       </div>
//     </section>
//   );
// }

// export default PublicClientLayout;


import React, { useEffect, useMemo } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import "../Auth/styles.css"; // must define .auth-section & .form-box

/* ---------- Background (gradient / image) from query ---------- */
function useAuthBgFromQuery() {
  const { search } = useLocation();

  return useMemo(() => {
    const p = new URLSearchParams(search);

    const normalizeHex = (v) => {
      if (!v) return "";
      const cleaned = v.startsWith("#") ? v.slice(1) : v;
      if (/^[0-9a-fA-F]{6}$/.test(cleaned) || /^[0-9a-fA-F]{3}$/.test(cleaned)) {
        return `#${cleaned}`;
      }
      return "";
    };

    const isHttpUrl = (s) => {
      if (!s) return false;
      try {
        const u = new URL(s);
        return u.protocol === "http:" || u.protocol === "https:";
      } catch {
        return false;
      }
    };

    const hexToRgb = (hex) => {
      if (!hex) return null;
      const h = hex.replace("#", "");
      const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
      const n = parseInt(full, 16);
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    };

    const darken = (hex, pct = 0.25) => {
      const rgb = hexToRgb(hex);
      if (!rgb) return hex;
      const k = 1 - pct;
      const r = Math.max(0, Math.min(255, Math.round(rgb.r * k)));
      const g = Math.max(0, Math.min(255, Math.round(rgb.g * k)));
      const b = Math.max(0, Math.min(255, Math.round(rgb.b * k)));
      return `#${[r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("")}`;
    };

    const rgba = (hex, a = 0.6) => {
      const rgb = hexToRgb(hex);
      if (!rgb) return "";
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`;
    };

    const primary = normalizeHex(p.get("primary"));
    const secondary = normalizeHex(p.get("secondary"));
    const bgHex = normalizeHex(p.get("bg"));

    const bgImageRaw = p.get("bg_image");
    const hasImage = isHttpUrl(bgImageRaw);
    const bgImageUrl = hasImage ? `url("${bgImageRaw}")` : "";

    // Decide gradient:
    // 1) primary/secondary → use them
    // 2) else if bg → darken(bg) → bg
    // 3) else → no gradient (fallback to default image in CSS)
    let gradient = "";
    if (primary && secondary) {
      gradient = hasImage
        ? `linear-gradient(135deg, ${rgba(primary, 0.65)}, ${rgba(secondary, 0.65)})`
        : `linear-gradient(135deg, ${primary}, ${secondary})`;
    } else if (bgHex) {
      const d = darken(bgHex, 0.25);
      gradient = hasImage
        ? `linear-gradient(135deg, ${rgba(d, 0.6)}, ${rgba(bgHex, 0.6)})`
        : `linear-gradient(135deg, ${d}, ${bgHex})`;
    }

    // If gradient but NO image, suppress default image by setting 'none'
    const bgImageVar = hasImage ? bgImageUrl : (gradient ? "none" : undefined);

    return { gradient, bgImageVar };
  }, [search]);
}

/* ---------- Title, Favicon, theme-color from query ---------- */
function useHeadFromQuery() {
  const { search } = useLocation();

  useEffect(() => {
    const p = new URLSearchParams(search);
    const incomingTitle = p.get("title");
    const faviconParam = p.get("favicon"); // URL or data:image/...
    const primary = p.get("primary");

    console.log("useHeadFromQuery:", { incomingTitle, faviconParam, primary });

    // 1) Title
    const prevTitle = document.title;
    if (incomingTitle && incomingTitle.trim()) {
      document.title = incomingTitle.trim();
    }

    // 2) Favicon
    // Helper: derive MIME type from extension (not required for data URLs)
    const guessType = (href) => {
      if (!href || href.startsWith("data:image/")) return ""; // browser will infer
      const u = href.split("?")[0].toLowerCase();
      if (u.endsWith(".svg")) return "image/svg+xml";
      if (u.endsWith(".png")) return "image/png";
      if (u.endsWith(".ico")) return "image/x-icon";
      if (u.endsWith(".jpg") || u.endsWith(".jpeg")) return "image/jpeg";
      return "";
    };

    const isValidFavicon = (s) => {
      if (!s) return false;
      if (s.startsWith("data:image/")) return true;
      try {
        const u = new URL(s);
        return u.protocol === "http:" || u.protocol === "https:";
      } catch {
        return false;
      }
    };

    // Remove ALL existing icon links so the browser can't keep using a cached one
    const removeIcons = () => {
      document
        .querySelectorAll(
          'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
        )
        .forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    };

    // Create and append a new <link ...> for the favicon
    const appendIcon = (rel, href) => {
      const link = document.createElement("link");
      link.rel = rel;

      // cache-buster to beat favicon caching (ignored for data URLs)
      const finalHref =
        href && !href.startsWith("data:image/")
          ? href + (href.includes("?") ? "&" : "?") + "v=" + Date.now()
          : href;

      if (finalHref) link.href = finalHref;

      const type = guessType(finalHref);
      if (type) link.type = type;

      // optional: sizes for better hints (won't break if not exact)
      if (!type || type === "image/png") link.sizes = "32x32";

      document.head.appendChild(link);
    };

    // Keep references to restore on unmount (optional)
    const prevLinks = Array.from(
      document.querySelectorAll(
        'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
      )
    ).map((el) => el.cloneNode(true));

    if (isValidFavicon(faviconParam)) {
      removeIcons();
      // add the common variants (some browsers prefer different rels)
      appendIcon("icon", faviconParam);
      appendIcon("shortcut icon", faviconParam);
      appendIcon("apple-touch-icon", faviconParam);
    }

    // 3) theme-color (nice touch for mobile address bar)
    const prevTheme = document.querySelector('meta[name="theme-color"]');
    let createdTheme = null;
    if (primary && /^#?[0-9a-fA-F]{3,6}$/.test(primary)) {
      const normalized = primary.startsWith("#") ? primary : `#${primary}`;
      const meta = document.createElement("meta");
      meta.name = "theme-color";
      meta.content = normalized;
      meta.setAttribute("data-auth-dynamic", "1");
      document.head.appendChild(meta);
      createdTheme = meta;
    }

    // Cleanup: restore previous icons & title
    return () => {
      document.title = prevTitle;

      // remove our inserted icons and put the originals back
      removeIcons();
      prevLinks.forEach((node) => document.head.appendChild(node));

      if (createdTheme) createdTheme.remove();
    };
  }, [search]);
}

/* ---------- Layout ---------- */
function PublicClientLayout({ children }) {
  const navigate = useNavigate();
  useHeadFromQuery();

  const { gradient, bgImageVar } = useAuthBgFromQuery();

  const styleVars = {
    "--auth-gradient": gradient || "none",
    "--auth-bg-image": bgImageVar, // 'url(...)' | 'none' | undefined (fallback to default)
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) navigate("/clients");
  }, [navigate]);

  return (
    <section className="auth-section" style={styleVars}>
      <div className="form-box">
        {children}
        <Outlet />
      </div>
    </section>
  );
}

export default PublicClientLayout;
